import { render, staticRenderFns } from "./Delete-User.vue?vue&type=template&id=7aebede8&scoped=true&"
import script from "./Delete-User.vue?vue&type=script&lang=js&"
export * from "./Delete-User.vue?vue&type=script&lang=js&"
import style0 from "./Delete-User.vue?vue&type=style&index=0&id=7aebede8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aebede8",
  null
  
)

export default component.exports